module.exports = __webpack_public_path__ + "img/d010_5.f6546920.png";